"use client";

import type { ScoreExplanation } from "@/lib/conditions/factor-explanations";
import { FactorFirst } from "./FactorFirst";

type Props = {
  explanation?: ScoreExplanation | null;
  boatCategory: "Club Dinghy" | "High Performance";
};

export function SailingRadar({ explanation, boatCategory }: Props) {
  if (!explanation) {
    return (
      <p className="rounded-[12px] border border-border-light bg-warm-bg p-4 text-[13px] text-text-muted">
        Factor explanation unavailable for {boatCategory.toLowerCase()} sailing.
      </p>
    );
  }

  return <FactorFirst explanation={explanation} title={`Why this ${boatCategory.toLowerCase()} score`} />;
}
